// extracted by mini-css-extract-plugin
export default {"navWrapper":"paymentHeader_navWrapper__6LYxH","topTipper":"paymentHeader_topTipper__49JkC","stripe":"paymentHeader_stripe__qiBhf"};